import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCi7EGYqr65N0Z15F0aDBGbbk6_rHfxuDw",
  authDomain: "error404-mysuru.firebaseapp.com",
  projectId: "error404-mysuru",
  storageBucket: "error404-mysuru.appspot.com",
  messagingSenderId: "610981807715",
  appId: "1:610981807715:web:c5b948c2e2bd03ec6e1a56",
  measurementId: "G-0K4RE5PBJP",
};

export const myFirebase = firebase.initializeApp(firebaseConfig);
export const firestore = myFirebase.firestore();
export const database = myFirebase.database();
